export const GRID_TYPE = {
	ASSET: 'Asset',
	CREATIVE: 'Creative',
	PREVIEW: 'Preview',
	VERSION: 'Version',
};
